import apiClient from './apiClient';
import ReincorporationDataStore from '../../datastores/ReincorporationDataStore';
import { reincorporation as schemaReincorporation } from './schemas';

class ReincorporationDataStoreGraphQL implements ReincorporationDataStore {
  client = apiClient();

  async programByCampus(campusId: string, periodId: string) {
    try {
      const response = await this.client.query({
        query: schemaReincorporation.programByCampus,
        variables: { campusId, periodId }
      });

      const { data } = response;

      return data.procedures.programByCampus;
    } catch (error) {
      throw new Error('Error "programByCampus"');
    }
  }

  async registerReincorporation(request: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReincorporation.registerReincorporation,
        variables: {
          procedureId: request.procedureId,
          newPeriod: request.newPeriod,
          requiresPayment: request.requiresPayment,
          campusId: request.campusId,
          careerId: request.careerId,
          modalityId: request.modalityId,
          newCampusId: request.newCampusId,
          newCampusDescription: request.newCampusDescription,
          newCareerId: request.newCareerId,
          newCareerDescription: request.newCareerDescription,
          newModalityId: request.newModalityId,
          newModalityDescription: request.newModalityDescription,
          reincorporationType: request.reincorporationType,
          academicPlan: request.academicPlan,
          careerPS: request.newAcadCareer,
          codProgCM: request.codProgCM,
          codPlanCM: request.codPlanCM,
          acadCareerCM: request.acadCareerCM
        }
      });
      const { data } = response;
      return {
        requestId: data?.registerReincorporation?.requestId,
        error: data?.registerReincorporation.error
      };
    } catch (error) {
      throw new Error('Error registerReincorporation');
    }
  }

  async activatePaymentReincorporation(
    procedureId: number,
    requestId: number,
    deliveryMode: string,
    career: string
  ) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReincorporation.activatePaymentReincorporation,
        variables: {
          procedureId,
          requestId,
          deliveryMode,
          career
        }
      });
      const { data } = response;
      return {
        requestId: data?.activatePaymentReincorporation?.requestId,
        error: data?.activatePaymentReincorporation.error
      };
    } catch (error) {
      throw new Error('Error activatePaymentReincorporation');
    }
  }
}

export default ReincorporationDataStoreGraphQL;
